export default __webpack_public_path__ + "static/media/BTCBULL.a88a6dc0.png";